import { memo } from 'react';
import Routes from '@router/Router';

const App = (): JSX.Element => <Routes />;

export default memo(App);
